export default function Marquee({ items = [], speed = 38 }) {
  const doubled = [...items, ...items];
  return (
    <div
      className="relative overflow-hidden border-y border-mgfc-magenta/40 bg-black/60 py-3"
      role="marquee"
      aria-label="MGFC headlines"
    >
      <div
        className="absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-mgfc-bg to-transparent"
        aria-hidden
      />
      <div
        className="absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-mgfc-bg to-transparent"
        aria-hidden
      />
      <div
        className="marquee-track gap-12 font-mono text-sm uppercase tracking-[0.3em] text-mgfc-magenta"
        style={{ animationDuration: `${speed}s` }}
      >
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center gap-12 whitespace-nowrap">
            <span className="text-mgfc-cyan">▸</span>
            <span>{item}</span>
            <span className="text-mgfc-orange">●</span>
          </span>
        ))}
      </div>
    </div>
  );
}
